import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { FC } from 'react';
import LinkWithHref from '../LinkWithHref';
import { Sections } from './NavBar';
import s from './NavBar.module.scss';

interface NavItemProps {
  section: string;
  textKey: string;
  biName: string;
  dataHook?: string;
  isMobileView?: boolean;
  isActive: boolean;
  onMobileClick: (section: string, biName: string) => void;
  onDesktopClick: (section: string, biName: string) => void;
  // Desktop scroll-spy props
  offset?: number;
  onSetActive?: () => void;
  hashSpy?: boolean;
}

const NavItem: FC<NavItemProps> = ({
  section,
  textKey,
  biName,
  dataHook,
  isMobileView,
  isActive,
  onMobileClick,
  onDesktopClick,
  offset,
  onSetActive,
  hashSpy,
}) => {
  const { t } = useTranslation();

  return (
    <li>
      <Text>
        <LinkWithHref
          href={`#${section}`}
          className={`${s.navItem} ${isActive ? s.active : ''}`}
          weight="thin"
          size="small"
          // Only add scroll-spy props for desktop
          {...(!isMobileView && {
            offset,
            onSetActive,
            smooth: true,
            spy: true,
            to: section,
            hashSpy,
          })}
          {...(dataHook && { 'data-hook': dataHook })}
          onClick={() =>
            isMobileView
              ? onMobileClick(section, biName)
              : onDesktopClick(section, biName)
          }
        >
          {section === Sections.ABOUT ? <span>{t(textKey)}</span> : t(textKey)}
        </LinkWithHref>
      </Text>
    </li>
  );
};

export default NavItem;
